import React from 'react';
import { withRouter } from 'react-router-dom';

import NavigationRoutes from './NavigationRoutes';
import { routerConfig } from './ExternalUrlRouterConfig';

const ExternalUrlNavigator = () => {
  return (
    //Sets the configurations in ExternalRouterConfig to be used and exposed
    <NavigationRoutes config={routerConfig} />
  );
};

export default withRouter(ExternalUrlNavigator);
